import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { downloadInBrowser } from 'utils/downloadInBrowser';
import { createGraphExportFileName } from '../helpers/createGraphExportFileName';
import { exportGraphWithoutHiddenElements } from './helpers/exportGraphWithoutHiddenElements';

export const exportToVsdx: GraphCommandFactory = (cmdContext) => async () => {
  const state = cmdContext.getState();

  // NIM-15436 this is a workaround over request body size, to be implemented better in the future
  const formData = new FormData();
  const f = new File(
    [
      JSON.stringify({
        graph: exportGraphWithoutHiddenElements(cmdContext.getState().graph),
      }),
    ],
    'graph.json',
    { type: 'application/json' },
  );
  formData.append('graph', f);
  const response = await cmdContext.api.request({
    url: '/graphs/vsdx',
    data: formData,
    formData: true,
    method: 'POST',
  });

  const vsdxFile = await response.blob();

  downloadInBrowser(`${createGraphExportFileName(state)}.vsdx`, vsdxFile);
};
